import React, { useEffect, useState } from "react";
import FormInput from "./FormInput";

function FormSelector({
  name,
  itemLabel,
  changeUserData,
  optionsObj,
  isAdditionally,
  defaultValue
}) {
  const [value, setValue] = useState();

  useEffect(() => {
    changeUserData(name, defaultValue);
  }, [defaultValue]);
  
  const onClickHandler = (e) => {
    changeUserData(name, e.target.value);

    if (isAdditionally) {
      setValue(null);
      if (
        e.target.value === "25FB8684-4742-4778-8D80-0C857EC465D4" ||
        e.target.value === "95BF98FA-F1D5-4300-AB77-545738F9DDBF"
      )
        setValue(e.target.value);
    }
  };

  if (!optionsObj) return;

  return (
    <div className="interface-form_group">
      <label className="interface-form_label" htmlFor={name}>
        {itemLabel}
      </label>
      <select
        id={name}
        className="interface_select"
        name={name}
        onChange={(e) => {
          onClickHandler(e);
        }}
      >
        {Object.keys(optionsObj).map((option) => {
          return (
            <option value={optionsObj[option]} key={optionsObj[option]}>
              {option}
            </option>
          );
        })}
      </select>
      {isAdditionally && value ? (
        name === "EnvironmentHotId" ? (
          <FormInput
            name={"PercentHot"}
            changeUserData={changeUserData}
            itemLabel={"Процентный состав раствора"}
          />
        ) : (
          <FormInput
            name={"PercentCold"}
            changeUserData={changeUserData}
            itemLabel={"Процентный состав раствора"}
          />
        )
      ) : null}
    </div>
  );
}

export default FormSelector;
